import {t} from "@lingui/core/macro";
import * as React from "react";
import {useState} from "react";
import {useHistory} from "react-router";

import Clickable from "@khanacademy/wonder-blocks-clickable";
import {View} from "@khanacademy/wonder-blocks-core";
import {Strut} from "@khanacademy/wonder-blocks-layout";
import {color, spacing} from "@khanacademy/wonder-blocks-tokens";
import {
    Footnote,
    HeadingLarge,
    LabelLarge,
} from "@khanacademy/wonder-blocks-typography";
import {Preferences} from "@khan/guide-ui";
import {useLocation} from "@khan/urls";

import GuideInterests from "./guide-interests.tsx";

type Tab = "preferences" | "interests";

const GuideSettings = ({kaid}: {kaid: string}): React.ReactElement => {
    const {hash} = useLocation();
    const initialTab = hash === "#interests" ? "interests" : "preferences";
    const [selectedTab, setSetSelectedTab] = useState<Tab>(initialTab);
    const history = useHistory();

    const handleSelectTab = (selection: Tab) => {
        setSetSelectedTab(selection);
        history.push(`#${selection}`);
    };

    return (
        <View>
            <HeadingLarge>{t`Khanmigo Settings`}</HeadingLarge>
            <Footnote>
                {t`Khanmigo settings are viewable and editable by your parent and teacher.`}
            </Footnote>
            <Strut size={spacing.medium_16} />
            <View style={styles.tabs}>
                <Clickable onClick={() => handleSelectTab("preferences")}>
                    {() => (
                        <LabelLarge
                            style={
                                selectedTab === "preferences" &&
                                styles.selectedTab
                            }
                        >
                            {t`Preferences`}
                        </LabelLarge>
                    )}
                </Clickable>

                <Clickable onClick={() => handleSelectTab("interests")}>
                    {() => (
                        <LabelLarge
                            style={
                                selectedTab === "interests" &&
                                styles.selectedTab
                            }
                        >
                            {t`Interests`}
                        </LabelLarge>
                    )}
                </Clickable>
            </View>
            <Strut size={spacing.large_24} />
            {selectedTab === "preferences" ? (
                <Preferences hideLinks={true} />
            ) : (
                <GuideInterests kaid={kaid} />
            )}
        </View>
    );
};

export default GuideSettings;

const styles = {
    tabs: {
        flexDirection: "row",
        gap: spacing.medium_16,
    },
    selectedTab: {
        color: color.blue,
        textDecoration: "underline",
        textUnderlineOffset: spacing.xSmall_8,
    },
} as const;
